import { AIIllustrationJobStatus, AIIllustrationJobStatusCellParams } from 'types/aiIllustration';

export function aiIllustrationJobStatusRenderer(params: AIIllustrationJobStatusCellParams): string {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = typeof params.value === 'string' ? parseInt(params.value, 10) : params.value;

  switch (status) {
    case AIIllustrationJobStatus.PENDING:
      // Hourglass icon for pending
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';

    case AIIllustrationJobStatus.RUNNING:
      // Spinner icon for running
      return '<span class="fa fa-spinner fa-spin" style="color: #2196f3;" title="Running"></span>';

    case AIIllustrationJobStatus.DONE:
      // Check circle icon for done
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Done"></span>';

    default:
      return '';
  }
}
